import DebtorBalancePreview from "./DebtorBalancePreview";

const PrintDebtorBalance: React.FC = () => {
  return (
    <div className="inner-container">
      <DebtorBalancePreview />
    </div>
  );
};

export default PrintDebtorBalance;
